import { render, staticRenderFns } from "./chooseFeeCombo.vue?vue&type=template&id=3dce0957&scoped=true"
import script from "./chooseFeeCombo.vue?vue&type=script&lang=js"
export * from "./chooseFeeCombo.vue?vue&type=script&lang=js"
import style0 from "./chooseFeeCombo.vue?vue&type=style&index=0&id=3dce0957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce0957",
  null
  
)

export default component.exports